import script from "./detailsinfo.vue?vue&type=script&setup=true&lang=js"
export * from "./detailsinfo.vue?vue&type=script&setup=true&lang=js"

import "./detailsinfo.vue?vue&type=style&index=0&id=6307a8ba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4e85b6a685c6792d169835830baf5532/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6307a8ba"]])

export default __exports__